import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
const NAMES = ['María', 'Gabriela', 'Valentina', 'Sofía', 'Isabella', 'Camila', 'Daniela', 'Alejandra', 'Fernanda', 'Paola', 'Lucía', 'Andrea', 'Karla', 'Natalia', 'Verónica', 'Patricia', 'Rosa', 'Carmen', 'Yolanda', 'Marisol', 'Esperanza', 'Lorena', 'Claudia', 'Diana', 'Mónica'];
const CITIES = ['Houston', 'Los Ángeles', 'Miami', 'Chicago', 'Dallas', 'Nueva York', 'San Antonio', 'Phoenix', 'Las Vegas', 'Denver', 'Orlando', 'Atlanta', 'San Diego', 'El Paso', 'Austin'];
function getRandom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function SocialProofToast() {
  const [visible, setVisible] = useState(false);
  const [person, setPerson] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay before first toast
    const initialDelay = setTimeout(() => showToast(), 4000);
    return () => clearTimeout(initialDelay);
  }, []);
  function showToast() {
    setPerson({
      name: getRandom(NAMES),
      city: getRandom(CITIES)
    });
    setVisible(true);
    // Hide after 4 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
      // Schedule next toast 15 seconds after hiding
      setTimeout(() => showToast(), 15000);
    }, 4000);
    return () => clearTimeout(hideTimer);
  }
  return <div className="fixed bottom-24 left-4 z-50 pointer-events-none" aria-live="polite" data-id="element-317">
      <AnimatePresence data-id="element-318">
        {visible && <motion.div key={`${person.name}-${person.city}`} initial={{
        x: -80,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} exit={{
        x: -80,
        opacity: 0
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 28
      }} className="flex items-center gap-3 px-4 py-3 rounded-xl shadow-xl max-w-xs" style={{
        backgroundColor: '#FFFFFF',
        border: '1px solid rgba(0,0,0,0.08)',
        boxShadow: '0 8px 32px rgba(0,0,0,0.15)'
      }} data-id="element-319">
            {/* Icon */}
            <div className="flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center" style={{
          backgroundColor: 'rgba(212,160,23,0.12)',
          border: '1px solid rgba(212,160,23,0.3)'
        }} data-id="element-320">
              <ShoppingBagIcon className="w-4 h-4" style={{
            color: '#D4A017'
          }} aria-hidden="true" data-id="element-321" />
            </div>

            {/* Text */}
            <div className="min-w-0" data-id="element-322">
              <p className="font-body text-xs font-semibold leading-snug" style={{
            color: '#1A1A1A'
          }} data-id="element-323">
                <span style={{
              color: '#B8860B'
            }} data-id="element-324">
                  {person.name}
                </span>{' '}
                de {person.city}
              </p>
              <p className="font-body text-xs leading-snug" style={{
            color: '#555555'
          }} data-id="element-325">
                acaba de descargar el Método Express
              </p>
              <p className="font-body text-xs mt-0.5" style={{
            color: '#AAAAAA'
          }} data-id="element-326">
                hace un momento
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}